import { useTranslation } from "react-i18next";
import { useMutation } from "@tanstack/react-query";
import { axiosInstance } from "../util/axios";
import { notification } from "antd";
import {
  GoogleConnectFormValues,
  GoogleReconnectFormValues,
} from "../types/google";
import { AxiosError } from "axios";

interface useGoogleConnectProps {
  onConnectSuccessful: () => void;
}

interface useGoogleReconnectProps {
  refetchStatuses: () => void;
}

export const useGoogleConnect = ({
  onConnectSuccessful,
}: useGoogleConnectProps) => {
  const { t } = useTranslation();
  return useMutation({
    mutationFn: (data: GoogleConnectFormValues) =>
      axiosInstance.post(`/auth/google`, data),
    onSuccess: () => {
      notification.success({
        message: t("toast.successfully-connected"),
        description: t("toast.provider-successfully-connected-description"),
      });
      onConnectSuccessful();
    },
    onError: () => {
      notification.error({
        message: t("toast.failed-to-connect-provider"),
        description: t("toast.please-check-your-credentials"),
      });
    },
  });
};

export const useGoogleReconnect = ({
  refetchStatuses,
}: useGoogleReconnectProps) => {
  const { t } = useTranslation();
  return useMutation({
    mutationFn: (data: GoogleReconnectFormValues) =>
      axiosInstance.post(`/auth/google/reconnect`, data),
    onSuccess: () => {
      notification.success({
        message: t("toast.successfully-reconnected"),
        description: t("toast.provider-successfully-reconnected-description"),
      });
      refetchStatuses();
    },
    onError: (error: AxiosError<AxiosError>) => {
      if (error.response?.data.message === "Email does not match") {
        notification.error({
          message: t("toast.failed-to-reconnect-provider"),
          description: t("toast.email-not-matching"),
        });
      } else {
        notification.error({
          message: t("toast.failed-to-reconnect-provider"),
          description: t("toast.please-check-your-credentials"),
        });
      }
    },
  });
};
